export const daysOfTheWeek = [
  {
    label: "Mon",
    value: "Mon",
  },
  {
    label: "Tue",
    value: "Tue",
  },
  {
    label: "Wed",
    value: "Wed",
  },
  {
    label: "Thu",
    value: "Thu",
  },
  {
    label: "Fri",
    value: "Fri",
  },
  {
    label: "Sat",
    value: "Sat",
  },
  {
    label: "Sun",
    value: "Sun",
  },
]

export const timeBlocks = [
  {
    label: "12MN-3AM",
    value: "12MN-3AM",
  },
  {
    label: "3AM-6AM",
    value: "3AM-6AM",
  },
  {
    label: "6AM-9AM",
    value: "6AM-9AM",
  },
  {
    label: "9AM-12NN",
    value: "9AM-12NN",
  },
  {
    label: "12NN-3PM",
    value: "12NN-3PM",
  },
  {
    label: "3PM-6PM",
    value: "3PM-6PM",
  },
  {
    label: "6PM-9PM",
    value: "6PM-9PM",
  },
  {
    label: "9PM-12MN",
    value: "9PM-12MN",
  },
]
